class DebugCommands {
    constructor(store) {
        this._store = store;
    }

    setCurrentPlaceholder(type, path) {
        this._store.commit("currentPlaceholder", { placeholder: { type, path } });
        return this;
    }
}

export default DebugCommands;